import * as React from 'react';
import './index.scss';
import { StageDefault } from '@/context.ts';
import Nto3 from '@hooks/web/tab1/nto3.tsx';
import Final from '@hooks/web/tab1/final.tsx';
interface TabsType {
  current: number,
  title: string,
  time: string,
  tips: string,
}
const { useEffect, useState, useContext } = React;
const Tab1: React.FC = () => {
  const { iStage, tabToastOpen } = useContext(StageDefault);
  const [IStage] = useState<number>(iStage > 3 ? 2 : 1);
  const [current, Current] = useState<number>(iStage > 3 ? 2 : 1);
  const [tabs] = useState<TabsType[]>([
    {
      current: 0,
      title: '金牌N进3',
      time: '11.13-11.19',
      tips: '统计所有公会在巅峰公会赛N进12/12进8/8进6阶段的总星光值，排名前3的公会成为金牌公会',
    },
    {
      current: 1,
      title: '决赛',
      time: '11.20-11.21',
      tips: '虎牙三大金牌公会巅峰对决，决出金牌公会冠亚季军',
    },
  ])
  return (
    <div
      className='web-tab1'
    >
      <div className='tab1_nav'>
        {
          [tabs].map((item: any, index: number) => (
            <ul key={index}>
              {
                item.map((navItem: TabsType, Index: number) => (
                  <li
                    key={Index}
                    className={
                      current === (Index + 1) ? 'on' : ''
                    }
                    onClick={
                      () => {
                        if (Index + 1 > IStage) {
                          tabToastOpen('该赛程暂未开始，敬请期待');
                          return;
                        };
                        Current(Index + 1);
                      }
                    }
                  >
                    <h2>{navItem.title}</h2>
                    <i></i>
                    <p>{navItem.time}</p>
                    <div className='tab-tips'>{navItem.tips}</div>
                  </li>
                ))
              }
            </ul>
          ))
        }
      </div>
      {
        // eslint-disable-next-line array-callback-return
        [Nto3, Final].map((item: any, index: number) => {
          if (index === (current - 1)) {
            const COMP = item;
            return <COMP key={index} />
          }
        })
      }
    </div>
  )
}

export default Tab1;